import { useDispatch } from 'react-redux'
import { EnvironmentUtils } from 'utils'
import { useRedirectAnimation } from 'hooks'
import { redirectToSta } from 'core/staIntegration/slices/staIntegration'
import requirementsRoutes from 'modules/requirements/Requirements/routing/routes'

const useRedirectToRequirements = (isDesktop?: boolean) => {
  const dispatch = useDispatch()
  const handleRedirectAnimation = useRedirectAnimation({ to: requirementsRoutes.root, delay: 1000 })
  const { shouldUseLegacyRequirements } = EnvironmentUtils.getPermissions('general')

  function handleRedirectToRequirements() {
    if (!shouldUseLegacyRequirements || !isDesktop) {
      handleRedirectAnimation()
      return
    }

    dispatch(
      redirectToSta({
        pluginName: 'Personnel',
        moduleName: null,
        command: 'PERSONALCARD',
        olp_req: 1,
      })
    )
  }

  return handleRedirectToRequirements
}

export default useRedirectToRequirements
